import React from "react";
import {Form, ListGroup} from "react-bootstrap";

export interface CheckboxMultiSelectOption {
    id: number;
    label: string;
}

interface CheckboxMultiSelectProps {
    idPrefix: string;
    legend: string;
    options: CheckboxMultiSelectOption[];
    selectedIds: number[];
    onToggle: (id: number) => void;
    disabled?: boolean;
    emptyMessage: string;
}

export default function CheckboxMultiSelect({
    idPrefix,
    legend,
    options,
    selectedIds,
    onToggle,
    disabled = false,
    emptyMessage,
}: CheckboxMultiSelectProps) {
    return (
        <fieldset disabled={disabled}>
            <legend className="h5">{legend}</legend>
            {options.length === 0 ? (
                <p className="text-muted">{emptyMessage}</p>
            ) : (
                <ListGroup>
                    {options.map(option => (
                        <ListGroup.Item key={option.id} className="d-flex align-items-center">
                            <Form.Check
                                type="checkbox"
                                id={`${idPrefix}-${option.id}`}
                                checked={selectedIds.includes(option.id)}
                                onChange={() => onToggle(option.id)}
                                label={option.label}
                            />
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}
        </fieldset>
    );
}
